import type { UserSession } from '@core/entities/UserSession';
import type { SessionRepository } from '@core/repositories/SessionRepository';
import { httpClient } from '@infrastructure/http/httpClient';
import { toAppError } from '@infrastructure/http/errorMapper';

interface UserSessionResponse {
  id: string;
  ip_address: string | null;
  device_name: string | null;
  platform: string | null;
  browser: string | null;
  last_activity_at: string;
  is_current: boolean;
}

interface UserSessionEnvelope {
  data: UserSessionResponse[];
}

const toSession = (payload: UserSessionResponse): UserSession => ({
  id: payload.id,
  ipAddress: payload.ip_address,
  deviceName: payload.device_name,
  platform: payload.platform,
  browser: payload.browser,
  lastActivityAt: payload.last_activity_at,
  isCurrent: payload.is_current,
});

export class SessionRepositoryImpl implements SessionRepository {
  async list(): Promise<UserSession[]> {
    try {
      const response = await httpClient.get<UserSessionEnvelope>('/sessions');
      return response.data.data.map(toSession);
    } catch (error) {
      throw toAppError(error);
    }
  }

  async revoke(id: string): Promise<void> {
    try {
      await httpClient.delete(`/sessions/${id}`);
    } catch (error) {
      throw toAppError(error);
    }
  }

  async revokeOthers(): Promise<void> {
    try {
      await httpClient.delete('/sessions/others');
    } catch (error) {
      throw toAppError(error);
    }
  }
}
